'use client'

import { useState, useRef, useEffect } from 'react'
import { ArrowRight, PanelTopOpen, PanelTopClose, RefreshCw, Bot, GalleryHorizontalEnd, ThumbsUp, ThumbsDown, MessageCircle, MessagesSquare, PaperclipIcon, MessageSquarePlus,XCircleIcon} from 'lucide-react'
import { Message,  paramChatbotRequest } from '@/app/models/interfaceChatbotconversation';
import { getCookie } from '../../helpers/cookies';
import "../../styles/chat.css";
import Citations from '../ChatCustom/Citations';
import DynamicTable from '../ChatCustom/DynamicTable';
import { useUser } from '@/app/context/UserContext';
import Dropdown from '../Elements/Dropdown';
import ConfigProject from '../ConfigProject/ConfigProject';
import { AccessType, Action, MessageType, StatusFile, TypeLayout } from '@/app/constants/enums';
import ListSourceView from '../Fuente/ListSourceView';
import Tags from '../ChatCustom/Tags';
import Avatar from '../Elements/Avatar';
import Loading from '../Elements/Loading'; 
import ButtonChat from '../Elements/Core/ButtonChat';
import TimeoutMessage from '../ChatCustom/TimeoutMessage';
import WelcomeMessage from '../ChatCustom/WelcomeMessage';
import { formatElapsedTime, getcurrentUser } from '@/app/helpers/functions';
import { iFeedbackRequest } from "../../models/interfaceChatBotFeedback";
import { chatbotSaveFeedback } from "@/app/services/chatbotsavefeedback";
import { iValorationRequest } from "../../models/interfaceChatBotValoration";
import { chatbotSaveValoration } from "@/app/services/chatbotsavevaloration";
import TextareaChat from '../Elements/Core/TextareaChat';
import AlertMessage from '../ChatCustom/AlertMessage';
import Markdown from '../ChatCustom/Markdown/Markdown';
import { chatbotMessageRouter } from '@/app/services/chatbotMessageRouter';
import { Conversation, RequestConversationCreate } from '@/app/models/interfaceConversation';
import { createConversation, listConversations, listMessages } from '@/app/services/conversationService';
import Modal from '../Elements/Modal';
import ConversationView from '../Conversation/ConversacionView';
import ConversationForm from '../Conversation/ConversationForm';
import { useHighlight } from '../Elements/useHighlight'; 
import { useConfig } from '@/app/context/ConfigContext';
import MarkdownPreview from '../ChatCustom/Markdown/MarkdownPreview';
import MarkdownTest from '../ChatCustom/Markdown/MarkdownTest';





 
export default function Chat() {
  const { queryParams, baseUrl } = useConfig();
   
  const [message, setMessage] = useState('')
  const [messages, setMessages] = useState<Message[]>([])
  const [messageComent, setMessageComent] = useState<Message|null>(null)
  const [showAttachmentOptions, setShowAttachmentOptions] = useState(false)
  const wordInputRef = useRef<HTMLInputElement>(null)
  const pdfInputRef = useRef<HTMLInputElement>(null)
  const imageInputRef = useRef<HTMLInputElement>(null) 
  const inputChatRef = useRef<HTMLTextAreaElement>(null);
  const [isLoading, setIsLoading] = useState(false);  // Estado de carga para esperar la respuesta de la API mensaje enviado
  const [isLoadingListMsg, setIsLoadingListMsg] = useState(false);  // Estado de carga para esperar la respuesta de la API listado de mensajes
  const [reload, setReload] = useState(false);
  const [attachedFiles, setAttachedFiles] = useState<File[]>([]);
  const fileInputRef = useRef<HTMLInputElement>(null);
  
  const endOfMessagesRef = useRef<HTMLDivElement>(null)  // Referencia para el scroll 
  const { user, setUser,
    accessType, userProject, myDocs, typeLayout, 
    currentConversation,setCurrentConversation,
    listConversation,setListConversation,
    changeConversation,setChangeConversation,
    addConversation, setAddConversation,  
    listConversationLoading } = useUser();// Accedemos al usuario logueado desde el contexto

  const  [sourceCount, SetSourceCount] = useState(0)
  const  [sourceDoneCount, setSourceDoneCount] = useState(0)
  const [isCommentModalOpen, setIsCommentModalOpen] = useState(false);
  const [commentText, setCommentText] = useState("");
  
   const msgWelcome = { 
                        id: Date.now().toString(),
                        text: userProject?.config?.prompt_params?.welcome_message|| "Bienvenido, ¿en qué puedo ayudarte hoy?",
                        timestamp: new Date().toISOString(),
                        citations: [],
                        schema_table:[],
                        tags:[],
                        type_msg:MessageType.Welcome,
                        time:(new Date()).getTime(),
                      } as Message 

  const handleListMessages = async (conv: Conversation) => {
    setIsLoadingListMsg(true);
    setMessages([]);
      try {   
        const response = await listMessages({
            project_id: conv.project_id,
            user_id: conv.user_id,
            conversation_id: conv.conversation_id,
          }, user, setUser); 
        if(response.data){
          const msgs = (response.data as Message[]).map(msg => ({
                        id: msg.id,
                        text: msg.text,
                        timestamp: msg.timestamp,
                        citations: msg.citations??[],
                        schema_table:msg.schema_table,
                        tags:msg.tags,
                        type_msg:msg.type_msg??MessageType.Warning,
                        valoration:msg.valoration,
                          //...msg,
                        typingEffect: false,
                        time:new Date(msg.timestamp).getTime()
                        } )
                  ); 
          setMessages([msgWelcome,...msgs]);
          //scrollToBottom();
        }
      } catch (error) {
        console.error('Error obteniendo respuesta del chatbot:', error);
      }
      finally {
        setIsLoadingListMsg(false); 
      }
  };

  
  useEffect(() => {
     if(changeConversation && currentConversation){
      handleListMessages(currentConversation);
     }else {
      setMessages([msgWelcome]);
     }
     setChangeConversation(false);
   }, [changeConversation]);

  //useEffect(() => {
  //    if (!currentConversation) {
  //      setMessages([msgWelcome]);
  //      return;
  //    } 
  //    if (addConversation) return;
//
  //    handleListMessages(currentConversation);
  //  }, [currentConversation?.conversation_id]);
   
  const scrollToBottom = () => {
    if (endOfMessagesRef.current) {
      endOfMessagesRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };

  useEffect(() => {
    const status = () => {
        if(typeLayout == TypeLayout.Advisor || typeLayout == TypeLayout.Conversation){
          if(userProject?.qa.length){
            setSourceDoneCount(userProject?.docs.filter(O=>O.status === StatusFile.Done).length + 1)
            SetSourceCount(userProject?.docs.length + 1);  
          }else{
            setSourceDoneCount(userProject?.docs.filter(O=>O.status === StatusFile.Done).length)
            //setSourceDoneCount(3)
            SetSourceCount(userProject?.docs.length);  
          } 
        }
        else if(typeLayout == TypeLayout.Personal){ 
          if(userProject.useDocs){ 
            setSourceDoneCount(userProject?.docs.filter(O=>O.status === StatusFile.Done).length)
            SetSourceCount(userProject?.docs.length);
          }else if(userProject.useMyDocs){ 
            setSourceDoneCount(myDocs?.filter(O=>O.name).length)
            SetSourceCount(myDocs?.filter(O=>O.name).length);  
          } 
        }  
    }
    status();
  }, [userProject?.qa, userProject?.docs, userProject?.useMyDocs, userProject?.useDocs,myDocs]);

  useEffect(() => {
    if(messages.length>0)
      scrollToBottom();
  }, [messages.length]);
 
 
  
  const handleAddConversation = async (): Promise<Conversation | null> => {
    const form = {
      name: message.trim().slice(0, 200),
      description: "",
      user_id: user ? user.email : getCookie("clientiditc"),
      project_id: userProject.project.id ?? "",
      company_code: userProject?.project?.company_code ?? "",
      company_name: userProject?.project?.company_name ?? "",
      env : userProject?.project?.env ?? "",
    } as RequestConversationCreate; 
    const response = await createConversation(form, user, setUser); 
    if (response.data) {
      const conversation = response.data as Conversation;
      setListConversation((prev:Conversation[]) => [conversation, ...prev]);
      return conversation;
    } 
    return null;
  };

  const inputChatRefClean=()=>{
    if (inputChatRef.current) {
        const el = inputChatRef.current;
        el.value = "";
        el.style.height = "auto";
        el.style.height = `${el.scrollHeight}px`;
      }
  } 

  const handleSend = async () => {
    if (message.trim()) {

      setTimedOut(false);
      setIsLoading(true);
      let conversation = currentConversation;
      let nuevaConversacion = (accessType == AccessType.LogIn && (!conversation || addConversation))
      try { 
        
        if (nuevaConversacion) {
          const newConversation = await handleAddConversation();
          if (!newConversation) throw new Error("No se pudo crear la conversación.");
          conversation = newConversation;
          setCurrentConversation(conversation);
          setAddConversation(false); 
        }

        const tempId = Date.now().toString();
        const newMessage: Message = {
          id: tempId,
          text: message,
          timestamp: new Date().toISOString(),
          vcitations:false,
          citations:[],
          schema_table:[],
          tags:[],
          time: (new Date()).getTime(),
          type_msg:MessageType.User,
          conversation_id: conversation?.conversation_id, 
        }
        setMessages((prev) => [...prev, newMessage]);
        setMessage(''); 

        const key_u = user.accessToken;//searchParams.get('key_u');
        const file_ids = userProject?.docs?.filter(doc=>doc.seleccionado)?.map(doc=>doc.file_id);        
        const my_file_ids = myDocs?.map(doc=>doc.file_id); 
        const paramsConversation: paramChatbotRequest = {
          question: newMessage.text,
          key_p: userProject.project.id?userProject.project.id:'',
          key_u: key_u?key_u:'',
          user_id: getcurrentUser(accessType, userProject, user),
          base_url: baseUrl,          
          //file_ids: [], // Retornar
          //my_collection: "fichas-tecnicas", // Retornar
	        //my_file_ids: ["H9WbDQ120qSg6vusyAO0"], // retornar
          file_ids: file_ids.length == 0 ?[]:file_ids,
          my_collection: getcurrentUser(accessType, userProject, user),
          my_file_ids: my_file_ids?.length == 0 ?[]:my_file_ids,
          prompt_params:userProject?.config?.prompt_params,
          config_params:userProject?.config?.config_params,
          user_data: {
            user_id:getcurrentUser(accessType, userProject, user)
          }, 
          reload: timedOut?true:reload,
          conversation_id:conversation?.conversation_id,//currentConversation?.conversation_id,
          access_type:accessType,
          attached_files: attachedFiles.map((f) => f.name),
        };
        inputChatRefClean();
        const response = await chatbotMessageRouter(paramsConversation, attachedFiles); 

        // setMessages((prevMessages) =>
        setMessages((prevMessages) =>
          prevMessages.map((msg) =>
            msg.id === tempId
              ? { ...msg, id: response.message_id_bd ? response.message_id_bd : tempId }
              : msg
          )
        );
        const botResponse: Message = {
          id: response.message_id_bd? response.message_id_bd:"",
          text: response.answer,
          timestamp: new Date().toISOString(),
          vcitations:false,
          citations:response.citations??[],
          schema_table:response.schema_table,
          tags:response.tags,
          time: (new Date()).getTime(),
          type_msg: response.satisfaction=='quota'?MessageType.Alert: MessageType.Bot,
          typingEffect:true,
          conversation_id: conversation?.conversation_id, 
        };
        setMessages((prevMessages) => [...prevMessages, botResponse]);
        setAttachedFiles([]);
        setReload(false);
      } catch (error) {
        console.error('Error obteniendo respuesta del chatbot:', error);
      }
      finally {
        setIsLoading(false);  // Desactivar estado de carga cuando la respuesta llega
        
      } 
     // Fin Llamada a la API del chatbot
     
    }
  }



  const handleReload =()=>{
    setReload(true);
    setMessages([]); 
  } 

  const handleAttachment = (type: 'word' | 'pdf' | 'image') => {
    setShowAttachmentOptions(false)
    if (type === 'word') {
      wordInputRef.current?.click()
    } else if (type === 'pdf') {
      pdfInputRef.current?.click()
    } else if (type === 'image') {
      imageInputRef.current?.click()
    }
  }
  const handleFileSelect = (event: React.ChangeEvent<HTMLInputElement>) => {
    const file = event.target.files?.[0];
    if (file) {
      setAttachedFiles([file]);
    }
  };

  const removeFile = () => {
    setAttachedFiles([]);
    if (fileInputRef.current) fileInputRef.current.value = "";
  };

  const handleFileUpload = (e: React.ChangeEvent<HTMLInputElement>, type: 'word' | 'pdf' | 'image') => {
    const file = e.target.files?.[0]
    if (file) { 
      // Aquí iría la lógica para manejar la subida del archivo
    }
  }

  const toggleCitation = (id: string) => {
    setMessages((prevItems) =>
      prevItems.map((item) =>
        item.id === id ? { ...item, vcitations: !item.vcitations } : item
      )
    );
  };
 
  const handleLike = async (msg:Message) => {
    if( msg.type_msg != MessageType.Bot)
      return; 
    setMessages((prevMessages) =>
      prevMessages.map((ms) =>
        (ms.id === msg.id && ms.type_msg===MessageType.Bot)
          ? { ...ms, valoration:(ms.valoration==="like" ? null : "like") }
          : ms
      )
    );

    const request: iValorationRequest = {
      company_code: userProject?.project?.company_code ?? "",
      project_id: userProject?.project?.id ?? "",
      user_id: getcurrentUser(accessType, userProject, user),
      message_id: msg.id,
      valoration: "like",
    };
    await chatbotSaveValoration(request);
  };

  const handleDislike = async (msg:Message) => {
    if(msg.type_msg != MessageType.Bot)
      return;

    setMessages((prevMessages) =>
      prevMessages.map((ms) =>
        (ms.id === msg.id && ms.type_msg===MessageType.Bot)
          ? { ...ms, valoration:(ms.valoration==="dislike" ? null : "dislike") }
          : ms
      )
    );
     
    const request: iValorationRequest = {
      company_code: userProject?.project?.company_code ?? "",
      project_id: userProject?.project?.id ?? "",
      user_id: getcurrentUser(accessType, userProject, user),
      message_id: msg.id,
      valoration: "dislike",
    };
    await chatbotSaveValoration(request);
    
  };

  const handleCommentSubmit = async (e: React.FormEvent,msg:any) => {
    e.preventDefault();
    if(commentText.trim()=='') return;
    setIsCommentModalOpen(false);
    setCommentText("");
    const request: iFeedbackRequest = {
      company_code: userProject?.project?.company_code ?? "",
      project_id: userProject?.project?.id ?? "",
      user_id: getcurrentUser(accessType, userProject, user),
      message_id: msg.id,
      feedback: commentText,
    };
    await chatbotSaveFeedback(request);
  };

  // fuentes
  const buttonFuenteRef = useRef<HTMLButtonElement>(null);
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const openDropdown = () => setIsDropdownOpen(true);
  const closeDropdown = () => setIsDropdownOpen(false);
  // config project 
  const [isModalOpenConfigProject, setIsModalOpenConfigProject] = useState(false); 
  const openModalConfigProject = () => setIsModalOpenConfigProject(true);
  const closeModalConfigProject = () => setIsModalOpenConfigProject(false);

 // avatar 
  const [imageError, setImageError] = useState(false); 
 // TimeOut
 const [timedOut, setTimedOut] = useState(false); 
 const [timedOutMinutes, setTimedOutMinutes] = useState(0); 
 const getMinutesSinceLastBotMessage = (messages: Message[]): number | null => { 
    // validamos mensajes del usuario
    if (!messages.filter(msg => msg.type_msg===MessageType.User).length) return null;
    // Validamos el ultimo mensaje si es ALERTA
    const lastBotMsgAlert = [...messages].reverse().find(msg => msg.time);
    if(lastBotMsgAlert?.type_msg === MessageType.TimeOut ) return null; 

    // Validamos ultimo mensaje
    const lastBotMsg = [...messages].reverse().find(msg => msg.type_msg===MessageType.User && msg.time);  
    if (!lastBotMsg) return null; 
    const now = new Date();
    const diffMs = now.getTime() - lastBotMsg.time;
    return diffMs / 1000 / 60;
  }; 



  useEffect(() => {
    if (accessType !== AccessType.Incognito) return; 

    const interval = setInterval(() => {
      const minutesPassed = getMinutesSinceLastBotMessage(messages);
      if (!isLoading && minutesPassed !== null && minutesPassed > userProject.config.config_params.max_minutes) { 
        setTimedOut(true);
        const Alert: Message = {
          id: (Date.now()+1).toString(),
          text: `Parece que se agotó el tiempo de espera. Han pasado **${formatElapsedTime(minutesPassed)}** desde el último mensaje.  
                ¡Pero no te preocupes! Estoy aquí si necesitas ayuda con algo más.`,        
          //sent: false, 
          timestamp: new Date().toISOString(),
          vcitations:false,
          citations:[],
          schema_table:[],
          tags:[],
          time: (new Date()).getTime(),
          type_msg:MessageType.TimeOut
        };

        setMessages((prevMessages) => [...prevMessages, Alert]); 
        setTimedOutMinutes(minutesPassed);
      }
    }, 1 * 1000); // ejecución cada minuto 
    return () => clearInterval(interval);
  }, [messages]);

  
// conversations 
    const buttonConversationRef = useRef<HTMLButtonElement>(null);
    const [isConversationDropdownOpen, setIsConversationDropdownOpen] = useState(false);
    const openConversationDropdown = () => setIsConversationDropdownOpen(true);
    const closeConversationDropdown = () => setIsConversationDropdownOpen(false);
    const { highlight, triggerHighlight } = useHighlight(2000);
    
    // form conversations 
    // const [modalConversation, setModalConversation] = useState(false);  
  
 
    const changeAddConversation = ()=>{
        // setCurrentConversation(conv);
        setMessages([msgWelcome])
        setAddConversation(true);
        triggerHighlight();
        inputChatRef.current?.focus();
        //if(currentConversation)
        //  handleListMessages(currentConversation);
    }
    
    useEffect(()=>{
      if(addConversation){
          triggerHighlight();
          inputChatRef.current?.focus();
      } 
    },[addConversation]);
 
    const [reloadKey, setReloadKey] = useState(0);
    const handleReloadMarkdown = () => {
        setReloadKey(prev => prev + 1);
      };
  return (
    <div className={`flex flex-col h-full`}>
       <div className="flex-1"> 
        <div className="flex flex-col md:flex-row items-center justify-center md:justify-between mx-auto w-full max-w-5xl space-y-4 md:space-y-0 md:space-x-4">
          {/* Chat area */}
          <div className="w-full overflow-y-auto scroll-custom px-5 pr-6 pb-5" >


            {/*
            <div className={`p-4 pt-2 pb-0 mt-2  n-chat-msj shadow bg-white text-sm text-gray-700 rounded-t-3xl rounded-r-3xl ` }>
               <button
                  onClick={handleReloadMarkdown}
                  className="mt-2 mb-1 text-xs text-blue-600 hover:text-blue-800 flex items-center gap-1 transition-colors duration-200"
                >
                  <span className="text-sm">🔄</span> Recargar
                </button>
             <MarkdownPreview  key={reloadKey}/>            
            </div>
          
            
            <div className={`p-4 pt-2 pb-0 mt-2  n-chat-msj shadow bg-white text-sm text-gray-700 rounded-t-3xl rounded-r-3xl ` }>
             <MarkdownTest/>
            </div>
              */}
            
            {isLoadingListMsg?
              <div className="flex items-center justify-center pt-32">  <Loading w="w-3" h="h-3" className="" /> </div>
            : 
              messages.map((msg) => 
                ( msg.type_msg === MessageType.TimeOut ? (
                  <TimeoutMessage key={msg.id} message={msg.text} />               
                ) : msg.type_msg === MessageType.Welcome ? (
                  <WelcomeMessage typingEffect={false} key={`welco_${msg.id}`} message={msg.text} />
                ) : msg.type_msg === MessageType.Alert ? (
                  <AlertMessage key={msg.id} message={msg.text} /> 
                ) :
                  <div key={`${msg.type_msg}_${msg.id}_${msg.conversation_id}`}
                    className={`flex ${msg.type_msg==MessageType.User ? 'justify-end' : 'justify-start'} animate-fadeIn relative`}>                  
                    <div className={`p-4 pt-2 pb-0 mt-2 ${accessType==AccessType.Incognito?'max-w-[90%]':'max-w-[70%]'}  n-chat-msj shadow bg-white text-sm text-gray-700 
                        ${msg.type_msg==MessageType.User ? 'rounded-t-3xl rounded-l-3xl' : 'rounded-t-3xl rounded-r-3xl '}` }>
                      
                      {(msg.type_msg==MessageType.User)&&(
                        <p>{msg.text}</p>
                      )}

                      {(msg.type_msg==MessageType.Bot)&& msg.text &&(
                        <>
                            {(msg.type_msg==MessageType.Bot)&&msg.tags&&(
                              <Tags tags={msg.tags} />
                            )}
                          <Markdown typingEffect={msg.typingEffect} > 
                            {msg.text}
                          </Markdown>
                      </>
                        
                      )} 
                      {(msg.type_msg==MessageType.Bot)&&msg.schema_table&&(
                        <DynamicTable jsonData={msg.schema_table} />
                      )} 

                      <p className="pt-2 text-right text-xs text-gray-400 flex justify-end items-center gap-1">  
                        {/*<span>{msg.timestamp}</span>*/}
                        <span>
                          {new Date(msg.timestamp).toLocaleDateString("es-PE", {
                            day: "2-digit",
                            month: "short",
                          })}{" "}
                          {new Date(msg.timestamp).toLocaleTimeString("es-PE", {
                            hour: "2-digit",
                            minute: "2-digit",
                          })}
                        </span>
                        {(msg.citations.length>0)&&(accessType==AccessType.LogIn)&& (msg.type_msg==MessageType.Bot)&&(
                        <span>
                          <ButtonChat
                            type="button"
                            actionCode={Action.CENTER_MSG_CITATION}
                            onClick={() => toggleCitation(msg.id)}
                            className="ml-auto rounded-full hover:bg-slate-200 transition duration-150 ease-in-out ">
                            {!msg.vcitations&&<PanelTopOpen strokeWidth={1} className="m-1" />}
                            {msg.vcitations&&<PanelTopClose strokeWidth={1} className="m-1" />}
                          </ButtonChat> 
                        </span>
                        )}
                      </p>
                      {((msg.citations.length>0)&&( msg.type_msg==MessageType.Bot) && msg.vcitations) &&(
                        <span>
                            <Citations documents={msg.citations} />
                            <p className="pt-2 text-right text-xs text-gray-400 flex justify-end items-center gap-1"> 
                              <button
                                onClick={() => toggleCitation(msg.id)}
                                className="ml-auto rounded-full hover:bg-slate-200 transition duration-150 ease-in-out ">
                                {!msg.vcitations&&<PanelTopOpen strokeWidth={1} className="m-1" />}
                                {msg.vcitations&&<PanelTopClose strokeWidth={1} className="m-1" />}
                              </button> 
                            </p> 
                        </span> 
                      )} 
                    </div>

                    <div className={`absolute bg-white 
                      -bottom-9 
                      border-b-[2px]
                      ${(msg.type_msg==MessageType.User)?
                        '-right-5 border-r-[2px] ':
                        '-left-5 border-l-[2px]'}
                      transform -translate-y-1/2 
                      rounded-full  
                      border-slate-300
                      flex items-center 
                      justify-center`}>
                        {(msg.type_msg==MessageType.User)?
                        <div>
                          {user?.photoURL && !imageError ? (
                            <img
                              src={user.photoURL}
                              alt="Avatar"
                              className="w-8 h-8 rounded-full"
                              onError={() => setImageError(true)} // Si la imagen falla, cambia a la inicial
                            />
                          ) : ( 
                            <Avatar className="rounded-full w-8 h-8" user={user} />
                          )} 
                        

                        </div>
                        :  
                        <>
                            <div className="relative">
                            {userProject?.project?.icono_bot ? (
                              <img
                                src={userProject.project.icono_bot}
                                alt="Bot"
                                className="w-8 h-8 rounded-full m-1 object-cover"
                              />
                            ) : (
                              <Bot strokeWidth={1.8} size={30} className="m-1" />
                            )}
                            {msg.type_msg === MessageType.Bot&&(
                            <div className="absolute top-0 left-12 flex items-center gap-2">
                                {/*
                              <ButtonChat
                                actionCode={Action.CENTER_CONFIG_AGENTE_BOT}
                                type="button"
                                className="rounded-full top-0 hover:bg-gray-300 "
                                onClick={openModalConfigProject}
                              >
                                <Settings strokeWidth={1} className="w-5 h-5 text-gray-700 " /> 
                              </ButtonChat> */}
                              <button 
                                onClick={() => handleLike(msg)} 
                                className={`rounded-full p-1 ${msg.valoration === "like" ? "bg-blue-200" : "hover:bg-gray-300"
                                }`}>
                                <ThumbsUp className={`w-5 h-5 ${
                                  msg.valoration === "like" ? "text-blue-600" : "text-gray-700"
                                }`} />
                              </button>

                              <button onClick={()=>handleDislike(msg)} 
                                className={`rounded-full p-1 ${
                                  msg.valoration === "dislike" ? "bg-red-200" : "hover:bg-gray-300"
                                }`}>
                                <ThumbsDown className={`w-5 h-5 ${
                                  msg.valoration === "dislike" ? "text-red-600" : "text-gray-700"
                                }`} />
                              </button>

                              <button 
                                onClick={() => {
                                    setIsCommentModalOpen(true);
                                    setMessageComent(msg)}
                                    } className="rounded-full top-0 hover:bg-gray-300">
                                <MessageCircle className="w-5 h-5 text-gray-700 hover:text-green-600" />
                              </button>
                              </div>
                            )}
                            </div>
                          </>
                          
                        }
                        
                    </div> 
                  </div>
                )
              )
            }
               {/* Indicador de carga (esperando respuesta del chatbot)  */} 
               {isLoading && ( 
                <div className="mb-5 mt-5 flex justify-start animate-fadeIn relative">
                  <div className="p-4 rounded-3xl max-w-[70%] "> 
                  </div> 
                  <div className={`absolute bg-white  -bottom-10  border-b-[2px]
                    -left-5 border-l-[2px] 
                  transform -translate-y-1/2 
                  rounded-full  
                  border-slate-300
                  flex items-center 
                  justify-center`}> 
                    <Loading w="w-2" h="h-2" className="absolute -top-2 left-5"/>
                    {userProject?.project?.icono_bot ? (
                      <img
                        src={userProject.project.icono_bot}
                        alt="Bot"
                        className="w-8 h-8 rounded-full m-1 object-cover"
                      />
                    ) : (
                      <Bot strokeWidth={1.8} size={30} className="m-1" />
                    )}
                  </div>
                </div> 
              )}
              <div ref={endOfMessagesRef} />  {/* Elemento de referencia para el scroll */}
          </div> 
        </div>
      </div>
      
      {/* Panel Inferior */}
      <div className='sticky bottom-0 z-0'> 

        {/*************************************************************************************************** */}


        <div 
          className={`flex flex-wrap justify-between 
              md:justify-between mx-auto w-full max-w-5xl space-y-0 
              md:space-y-0 space-x-4 
              md:space-x-4 
              md:p-4
              p-1
              pb-1
              n-rounded n-bg-global  
            
            ${accessType==AccessType.LogIn?'lg:pb-10':'pb-2'} `}
          >
            
          {accessType==AccessType.LogIn?             
              <div className="flex items-center mb-2 hidden_nooo sm:block_nooo" >
                <ButtonChat
                  type="button"
                    actionCode={Action.CENTER_FUENTE_CHAT}
                    ref={buttonFuenteRef}
                    className="flex items-center gap-2 px-2 py-2 border rounded-full bg-gray-100 hover:bg-gray-200 transition-colors mr-3
                          md:px-3 md:py-1.5 md:gap-1 lg:px-4 lg:py-2 lg:gap-2"
                    onClick={
                      (user && userProject?.project?.created_user === user.email) ||
                      (user && userProject?.project?.permissions.filter(O => O.email === user.email && O.administrator).length >= 1)
                        ? openDropdown
                        : undefined
                    }
                  > 
                  <GalleryHorizontalEnd  strokeWidth={1} className="w-6 h-6 text-gray-700 md:w-5 md:h-5" />
                  <span 
                    className={` ${sourceCount==0 || sourceDoneCount<sourceCount ? 'text-red-600' : 'text-gray-600'} font-medium text-sm md:text-sm lg:text-sm hidden sm:inline `}
                  > 
                    {sourceDoneCount<sourceCount?
                      <div className="inline-flex items-center space-x-2"> 
                        {sourceDoneCount} de {sourceCount} fuente(s) disponible(s) <Loading w="w-1" h="h-1" className="" /> </div> : 
                      sourceCount+" fuente(s)"} 
                  </span>
                </ButtonChat>
              
                { typeLayout !== TypeLayout.Personal?
                  <Dropdown 
                  isOpen={isDropdownOpen} 
                  onClose={closeDropdown} 
                  buttonRef={buttonFuenteRef}
                  positionPreference="top" // Puedes cambiar a "top", "bottom", "left", "right"
                  >
                    <div className='w-96 max-h-96 overflow-x-hidden scroll-custom ' 
                    onClick={(e) => e.stopPropagation()}
                    >  
                      <ListSourceView />
                      
                    </div>
                  </Dropdown>:""
                }
                
                  
                <ButtonChat
                    type="button"
                    disabled={isLoading}
                    actionCode={Action.CENTER_CONVERSATION_VIEW} 
                    ref={buttonConversationRef}
                    className="flex items-center gap-2 px-2 py-2 border rounded-full bg-gray-100 hover:bg-gray-200 transition-colors mr-3
                          md:px-3 md:py-1.5 md:gap-1 lg:px-4 lg:py-2 lg:gap-2"
                    onClick={openConversationDropdown}
                  > 
                    <MessagesSquare  strokeWidth={1} className="w-6 h-6 text-gray-700 md:w-5 md:h-5" />
                  <span 
                    className={` text-gray-600 font-medium text-sm md:text-sm lg:text-sm hidden sm:inline `}
                  >  
                      {listConversationLoading?
                        <Loading w="w-1" h="h-1" className="p-0" />:
                        <>{listConversation.length} Conversacion(es)</>
                      } 
                  </span>
                </ButtonChat> 
                <Dropdown 
                    isOpen={isConversationDropdownOpen} 
                    onClose={closeConversationDropdown} 
                    buttonRef={buttonConversationRef}
                    positionPreference="top"// Puedes cambiar a "top", "bottom", "left", "right"
                  > 
                    <div className='w-96 max-h-96 overflow-x-hidden scroll-custom px-5' 
                    onClick={(e) => e.stopPropagation()}
                    >  
                      <ConversationView/>
                    </div>
                </Dropdown>
                {currentConversation&&
                  <ButtonChat
                      type="button"
                      disabled={isLoading}
                      actionCode={Action.CENTER_CONVERSATION_ADD} 
                      className="flex items-center gap-2 px-2 py-2 border rounded-full bg-gray-100 hover:bg-gray-200 transition-colors mr-3
                            md:px-3 md:py-1.5 md:gap-1 lg:px-4 lg:py-2 lg:gap-2"
                      onClick={changeAddConversation}
                    > 
                      <MessageSquarePlus  strokeWidth={1} className="w-6 h-6 text-gray-700 md:w-5 md:h-5" />
                    <span className={` text-gray-600 font-medium text-sm md:text-sm lg:text-sm hidden sm:inline `} >  
                        Nueva conversación
                    </span>
                  </ButtonChat> 
                }
                

            </div> 
          :
            <div className="flex items-center mb-2 hidden_nooo sm:block_nooo" >
              <ButtonChat
                    type="button"
                    actionCode={Action.CENTER_MSG_RESET}  
                    disabled={!messages.length} 
                    className={`  ${messages.length>0 ? ' hover:bg-gray-200' : 'opacity-50'}  flex items-center gap-2 px-2 py-2 border rounded-full bg-gray-100  transition-colors mr-3
                          md:px-3 md:py-1.5 md:gap-1 lg:px-4 lg:py-2 lg:gap-2`} 
                    onClick={handleReload}
                  > 
                    <RefreshCw  strokeWidth={1} className="w-6 h-6 text-gray-700 md:w-5 md:h-5" />
                  <span 
                    className={` text-gray-600 font-medium text-sm md:text-sm lg:text-sm hidden sm:inline `}
                  >  
                      Reiniciar
                  </span>
                </ButtonChat> 
            </div>
          }
          {/*estado actual */}     
          {addConversation ? (
            <span className="  text-sm font-medium text-gray-800 truncate max-w-[220px] block px-2 py-1 transition-all duration-300">
              Nueva conversación
            </span>
          ) : (
            <span className=" text-sm font-medium text-gray-800 truncate max-w-[220px] block px-2 py-1 transition-all duration-300" title={currentConversation?.name}>
              {currentConversation?.name}
            </span>
          )} 

          {/* Zona Text chat */}
          <div className={`flex  px-1 py-1 w-full rounded-[30px] items-end 
                        transition-all duration-500 border
                        ${highlight
                          ? "border-[#0078D7] shadow-[0_0_15px_rgba(0,120,215,0.6)]"
                          : "bg-gray-200"
                      } `}>
            <div className="flex flex-col w-full">
            {attachedFiles.length > 0 && (
              <div className="flex items-center gap-2 p-2 rounded-md mb-2">
                {attachedFiles[0].type.startsWith("image/") ? (
                  <img
                    src={URL.createObjectURL(attachedFiles[0])}
                    alt="preview"
                    className="w-[120px] h-[120px] object-cover rounded-lg border border-gray-300"
                  />
                ) : (
                  <div className="flex items-center gap-1">
                    <PaperclipIcon className="h-5 w-5 text-gray-600" />
                    <span className="text-sm">{attachedFiles[0].name}</span>
                  </div>
                )}
                <button
                  onClick={removeFile}
                  className="text-gray-500 hover:text-red-500"
                  disabled={isLoading}
                >
                  <XCircleIcon className="h-5 w-5" />
                </button>
              </div>
            )}

            <div className="flex px-1 py-0 w-full rounded-[30px] items-end">
              {/*
              <ButtonChat
                actionCode={Action.CENTER_ATTACH_FILE}
                type="button"
                className="rounded-full text-gray-500 p-1 bg-gray-50 hover:opacity-50 transition-colors"
                onClick={() => fileInputRef.current?.click()}
                aria-label="Adjuntar Archivo"
              >
                <PaperclipIcon strokeWidth={1} className="m-2" />
              </ButtonChat>
              */}
              <input
                type="file"
                ref={fileInputRef}
                className="hidden"
                onChange={handleFileSelect}
              />

            
            <TextareaChat
              ref={inputChatRef}
              actionCode={Action.CENTER_MSG_CHAT} 
              value={message}
              onChange={(e) => setMessage(e.target.value)} 
              onKeyDown={(e) => { 
                if (e.key === "Enter") {
                  e.preventDefault();
                // Bloquear enter si está cargando
                if (isLoading) {
                  return;
                } 
                // Si no está cargando y cumple condiciones => enviar
                if (userProject && sourceCount > 0 && message) {                  
                  handleSend();
                }
              }
              /*
                  if (
                    e.key === "Enter" &&
                    userProject &&
                    !isLoading &&
                    sourceCount > 0 &&
                    message
                  ) {
                    e.preventDefault(); // evita que se inserte el salto de línea
                    handleSend();
                  }
                  */
                }}
                className="w-full bg-transparent px-1 focus:outline-none resize-none self-center"
                placeholder="Comienza a escribir..."
                rows={1}
                onInput={(e) => { 
                  const target = e.target as HTMLTextAreaElement; 
                  target.style.height = "auto"; 
                  target.style.height = `${target.scrollHeight}px`; }}
              />
              <ButtonChat
              type="button"
              actionCode={Action.CENTER_MSG_SENT} 
              className={`primary rounded-full p-1 text-white ${!userProject||isLoading||sourceCount==0||!message ? 'opacity-50' : ''}   hover:opacity-50 transition-colors`} 
              onClick={handleSend}
              aria-label="Enviar mensaje"
              disabled={!userProject||isLoading||sourceCount==0||!message}
            >
            <ArrowRight strokeWidth={1} className="m-2"/> 
            </ButtonChat>
            
            </div>

            
          </div>
              
            {/*
          <InputChat
              actionCode={Action.CENTER_MSG_CHAT} 
              value={message}
              onChange={(e) => setMessage(e.target.value)}
              onKeyPress={(e) => (e.key === 'Enter' && userProject && !isLoading && sourceCount>0 && message) && handleSend()}
              className="flex-1 resize-none bg-transparent px-4 focus:outline-none
              md:font-bold ms:font-bold
              " 
              //rows={1}
              placeholder="Comienza a escribir..." />
               */}
          
          </div>
          {/*<a href="#" className="text-blue-600 whitespace-nowrap hover:text-slate-400">Guía del notebook</a>*/}
        </div>
      </div> 

          <ConfigProject isOpen={isModalOpenConfigProject} onClose={closeModalConfigProject} initialData={userProject?.config}  />

          {/*
          <Modal
            isOpen={modalConversation}
            onClose={() => setModalConversation(false)}
          >
            <ConversationForm
              onClose={() => setModalConversation(false)}
              onUpdateList={fetchConversations}
              editingConv={null} 
              /> 
          </Modal>
          */}
          {/* Modal de comentario */}
          <Modal
            isOpen={isCommentModalOpen}
            onClose={() => setIsCommentModalOpen(false)}
            btnClose={false}
          >
            <div className="p-6
            min-w-[500px] min-h-[200px]
            ">
                <h2 className="text-lg font-semibold mb-3">Dejar un comentario</h2>
                <form onSubmit={(e) => handleCommentSubmit(e, messageComent)}>
                  <textarea
                    value={commentText}
                    onChange={(e) => setCommentText(e.target.value)}
                    className="border w-full p-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700 mb-2"
                    rows={4}
                    placeholder="Escribe tu comentario aquí..."
                  />
                  <div className="flex justify-end gap-2">
                    <button
                      type="button"
                      onClick={() => setIsCommentModalOpen(false)}
                      className="bg-gray-200 hover:bg-gray-300 text-gray-700  py-2 px-4 mr-2 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                    >
                      Cancelar
                    </button>
                    <button
                      type="submit"
                      className="bg-blue-600 hover:bg-blue-700 text-white py-2 px-4 n-fmr-input focus:outline-none focus:ring-1 focus:ring-blue-700"
                    >
                      Guardar
                    </button>
                  </div>
                </form>
              </div>
          </Modal>
    </div>
    
  )
}